import React, { useEffect, useState } from 'react';
import { fetchMasterChefMetroBalance } from '../services/ethereumService';

const MasterChefCard: React.FC = () => {
    const [balance, setBalance] = useState<string>('');
    const [error, setError] = useState<string>('');
    const [loading, setLoading] = useState<boolean>(true);

    useEffect(() => {
        const fetchBalance = async () => {
            try {
                const metroBalance = await fetchMasterChefMetroBalance();
                // Direkt den String-Wert verwenden, da wir jetzt fertig formatierte Daten zurückgeben
                setBalance(metroBalance);
                setError('');
            } catch (err) {
                setError('Failed to fetch balance');
                console.error(err);
            } finally {
                setLoading(false);
            }
        };

        fetchBalance();
        const interval = setInterval(fetchBalance, 30000); // Refresh every 30 seconds
        return () => clearInterval(interval);
    }, []);
    return (
        <div className="masterchef-card">
            <h3>
                <svg width="18" height="18" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" style={{ marginRight: '8px' }}>
                    <path d="M5 8H19M5 12H15M5 16H12" stroke="url(#grad2)" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                    <defs>
                        <linearGradient id="grad2" x1="5" y1="8" x2="19" y2="16" gradientUnits="userSpaceOnUse">
                            <stop stopColor="var(--metro-accent)" />
                            <stop offset="1" stopColor="var(--metro-accent-secondary)" />
                        </linearGradient>
                    </defs>
                </svg>
                MasterChef
            </h3>
            <div className="masterchef-content">
                {loading ? (
                    <div className="loading">
                        <div className="loading-pulse"></div>
                    </div>
                ) : error ? (
                    <div className="error">{error}</div>
                ) : (
                    <>
                        <div className="wallet-info">
                            <div className="address">0x1a5D...03da</div>
                            <div className="balance-label">Balance</div>
                            <div className="balance">
                                {balance} 
                                <span className="token-symbol">METRO</span>
                            </div>
                        </div>
                        {/* <div className="card-actions">
                            <button className="action-button">
                                <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M12 5V19M5 12H19" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                                </svg>
                                View Details
                            </button>
                        </div> */}
                    </>
                )}
            </div>
            <style>
                {`
                    .wallet-info {
                        display: flex;
                        flex-direction: column;
                        gap: 8px;
                    }
                    .balance-label {
                        font-size: 12px;
                        color: var(--metro-text-secondary);
                        text-transform: uppercase;
                        letter-spacing: 0.5px;
                        margin-top: 8px;
                    }
                    .token-symbol {
                        color: var(--metro-accent);
                        font-weight: normal;
                        margin-left: 4px;
                    }
                    .card-actions {
                        margin-top: 16px;
                        display: flex;
                        justify-content: flex-end;
                    }
                    .action-button {
                        background: none;
                        border: 1px solid var(--metro-card-border);
                        border-radius: 6px;
                        padding: 8px 12px;
                        color: var(--metro-text);
                        font-size: 14px;
                        cursor: pointer;
                        display: flex;
                        align-items: center;
                        gap: 6px;
                        transition: all 0.2s ease;
                    }
                    .action-button:hover {
                        background-color: rgba(61, 90, 254, 0.1);
                        border-color: var(--metro-accent);
                    }
                    .loading-pulse {
                        width: 120px;
                        height: 24px;
                        background: linear-gradient(90deg, 
                            var(--metro-card-border) 0%, 
                            var(--metro-dark-secondary) 50%,
                            var(--metro-card-border) 100%);
                        background-size: 200% 100%;
                        border-radius: 4px;
                        animation: pulse 1.5s infinite;
                    }
                    @keyframes pulse {
                        0% {
                            background-position: 0% 0%;
                        }
                        100% {
                            background-position: -200% 0%;
                        }
                    }
                `}
            </style>
        </div>
    );
};

export default MasterChefCard; 